export default __webpack_public_path__ + "static/media/dojoji_logo_light.30d11f3d.png";